<div class="layout-topbar">
    <div class="layout-topbar-wrapper">

        <div class="layout-topbar-right">

            <ul class="layout-topbar-actions">
                <app-notificationlist></app-notificationlist>
                
                <li #profile class="topbar-item user-profile"
                    [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                    <a href="#" (click)="appMain.onTopbarItemClick($event,profile)">
                        <img class="profile-image" src="assets/images/logos/came-logo.png" alt="user-img">
                    </a>

                    <ul class="fadeInDown">
                        <li class="layout-submenu-header">
                            <i class="text-900 pi text-3xl cm-user"></i>
                            <div class="profile-info">
                                <h6>{{username}}</h6>
                            </div>
                        </li>
                        <li role="menuitem">
                            <a (click)="userProfile()">
                                <i class="pi cm-cog"></i>
                                <h6>{{ 'USER_PROFILE' | translate}}</h6>
                            </a>
                        </li>
                        <li role="menuitem">
                            <a href="#" (click)="logout()">
                                <i class="pi cm-logout"></i>
                                <h6>{{ 'LOGOUT' | translate}}</h6>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

        </div>
    </div>
</div>
